import * as React from 'react';
import { CalendarActions, ICalendarState, IEventMonth } from '@adage/ace-calendar';
import { ICalendar } from '@adage/calendar/services/calendar';
import { IArenaEvent } from '../classes/event';
import { connect } from 'react-redux';
import * as moment from 'moment';
import GridMonthView from '../views/grid-month';
interface ExternalProps {
   
}
interface GridMonthProps {
    eventMonth: ICalendar<IArenaEvent>;
    monthMoment: moment.Moment;
}

interface StateToProps {
  
}

interface MonthState {
   
}

type MonthProps = ExternalProps & StateToProps & GridMonthProps

export class GridMonthComponent extends React.Component<MonthProps, MonthState> {


    render() {
        return (
            <div>
                <GridMonthView monthMoment={this.props.monthMoment} eventMonth={this.props.eventMonth} />
              
            </div>
        );
    }
}
function mapStateToProps(state: ICalendarState<IArenaEvent>, ownProps: ExternalProps): StateToProps {
   
    return {
      
    }
}

export default connect<StateToProps, null>(mapStateToProps, null)(GridMonthComponent);


// WEBPACK FOOTER //
// ./app/calendar/components/grid-month.tsx